module.exports = __webpack_public_path__ + "img/vast-whey-1.e3f2300f.jpg";